var link_preview_default = {
  "fontElementMap": "zggwr",
  "linkPreviewContainer": "wnUzB",
  "linkPreview": "QFX-R",
  "linkPreviewImage": "_7JRBn",
  "linkPreviewPlaceholder": "LGhI-",
  "linkPreviewInfo": "ls6qy",
  "linkPreviewTitle": "RA-Ss",
  "linkPreviewDescription": "_3lwTi",
  "linkPreviewUrl": "rvfOx",
  "linkPreviewResponsiveImage": "QNS-c",
  "loadingContainer": "-WSW6",
  "errorIcon": "Mbm1l",
  "errorInfo": "oASsS",
  "errorContainer": "twf1Y",
  "overlay": "_2uBmL",
  "thumbnailEnd": "bKvEB",
  "thumbnailStart": "mDvr6",
  "thumbnailTop": "t0b2x"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
